import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ec23847"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-header font-medium" }
const _hoisted_2 = { class: "customer-header__name" }
const _hoisted_3 = { class: "customer-header__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.customer.companyName), 1),
    _createElementVNode("span", _hoisted_3, " (" + _toDisplayString(_ctx.customer.id) + ")", 1)
  ]))
}